import { Component } from '@angular/core';
import { environment } from '../../../../environments/default/environment';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    standalone: false
})
export class LogoComponent {
    env = environment;
}
